/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { RxAgentMetadata } from "./RxAgentMetadata";

export interface RxAgentProgressionRequest {
  /** The conversation this progression operates within, if one exists */
  conversation_id?: string | null;
  /** The clinic request this progression serves, which scopes it: entering the flow via a different request gets a different progression. */
  clinic_request_id?: string | null;
  flow_name: "rx_agent";
  metadata?: RxAgentMetadata;
}
